import { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Motion";
import { SectionHead } from "@/components/Common";
import { MaskLines } from "@/components/Motion";
import { FAQ } from "@/data/site";

// Adds FAQPage structured data so Google can read the questions on this page.
const useFaqSchema = (items) => {
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.dataset.faq = "true";
    el.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
    });
    document.head.appendChild(el);
    return () => { el.remove(); };
  }, [items]);
};

export const FaqSection = ({ items = FAQ, lines = ["Frequently", "Asked Questions"], eyebrow = "Questions", className = "bg-white" }) => {
  useFaqSchema(items);
  return (
    <section data-testid="faq-section" className={`${className} py-24 md:py-32`}>
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHead eyebrow={eyebrow} title={<MaskLines onView lines={lines} />} />
        </div>
        <Reveal className="lg:col-span-8">
          <Accordion type="single" collapsible className="border-t border-[#14263D]/15">
            {items.map(([q, a], i) => (
              <AccordionItem key={q} value={`q${i}`} className="border-b border-[#14263D]/15">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-xl font-semibold text-[#14263D] hover:no-underline md:text-2xl">
                  <span className="flex gap-5"><span className="mt-1.5 font-mono text-xs text-[#A52A32]">{String(i + 1).padStart(2, "0")}</span>{q}</span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pl-10 text-base leading-relaxed text-[#5F6B76]">{a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
